import axios from 'axios'
import config from '../../config'
import { request_with_retry } from '../../helpers/request_retry'

const readRequestOptions = {
    timeout: 12000
}

const get_company_departments = async () => {
    try {
        return await request_with_retry(() => {
            return axios.get(`${config.BACKEND_URL}/admins/company-departments`, readRequestOptions)
        })
    } catch (error) {
        console.error('[Error | getCompanyDepartments] > ', error)
        return {
            ok: false,
            error
        }
    }
}

const create_company_department = (name, roles, companyHead = false) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.BACKEND_URL}/admins/company-departments`, {
            name,
            roles,
            companyHead
        })
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | createCompanyDepartment] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

const update_company_department = (departmentId, name, roles, companyHead = false) => {
    return new Promise((resolve, reject) => {
        axios.put(`${config.BACKEND_URL}/admins/company-departments/${departmentId}`, {
            name,
            roles,
            companyHead
        })
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | updateCompanyDepartment] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

export {
    get_company_departments,
    create_company_department,
    update_company_department
}
